import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.div`
  padding-left: ${Spacing.S12};
`
